import { useCallback } from 'react'
import styles from './PaperCard.module.css'
import { jeeTestSchedule } from 'api/api'
import config from 'config'
import {
    test_begin,
    result_begin,
    begin_test_fail,
    result_show_fail,
} from 'utils/customWebengage'
import { getExamType } from 'utils/common'

const PaperCard = ({
    heading,
    buttonLabel,
    buttonVariant,
    profileData,
    examData,
    examDate,
    test_name,
    token,
    isDisabled,
}) => {
    const examType = getExamType()
    const buttonStyles = {
        'Begin Test': {
            backgroundColor: '#00B0F5',
            color: '#FFFFFF',
            border: '#E0F6FF solid 2px',
        },
        Missed: {
            backgroundColor: '#F8F2F2',
            color: '#FA0505',
            border: '#FBFBFB solid 2px',
            cursor: 'default',
        },
        'View Result': {
            backgroundColor: 'white',
            color: '#00B0F5',
            border: '#F4F4F5 solid 2px',
        },
    }
    const addHours = (time, timeZone = true) => {
        const examDateTime = new Date(`${examDate}T${time}`)
        const newDateTime = new Date(examDateTime.getTime() + 48 * 60 * 60 * 1000)
        if (timeZone) {
            return newDateTime.toISOString().replace('Z', '+05:30')
        } else {
            return newDateTime.toISOString()
        }
    }

    const payload = {
        tenant_id: config.TENANT_TOKEN_ID,
        user_id: profileData.roll_number,
        exam_short_code: examData.exam_short_code,
        external_schedule_id: examData.external_schedule_id,
        exam_start_time: new Date().toISOString(),
        exam_end_time: addHours(examData.start_time, false),
        result_date_time: addHours(examData.start_time),
        dob: profileData.student_dob + 'T18:30Z',
        stream: profileData.classtream,
        groups: {
            state: profileData.exam_state,
        },
        attempt_state: 'live',
        event_type: examData.btn_txt === 'Begin Test' ? 'exam' : 'result',
        reset_cutoff_time: addHours(examData.start_time),
        klass: profileData.class,
        we_user_id: '',
    }

    const handleBeginExam = useCallback(async (data, heading, token) => {
        jeeTestSchedule(data, token)
            .then((res) => res.data)
            .then((res) => {
                profileData['test_paper'] = heading ? heading : ''
                profileData['exam_date_jee'] = examDate ? examDate : ''
                profileData['test_paper_name'] = test_name ? test_name : ''
                if (res.data.exam_url) {
                    test_begin('7_Begin_Test_Click', data, profileData, examType)
                    window.open(res.data.exam_url, '_blank')
                } else if (res.data.result_url) {
                    result_begin('10_View_Result_Click', data, profileData, examType)
                    window.open(res.data.result_url, '_blank')
                }
            })
            .catch((err) => {
                if (err) {
                    profileData['test_paper_name'] = test_name ? test_name : ''
                    if (buttonLabel == 'View Result') {
                        result_show_fail(
                            '17_Result_View_Failure',
                            profileData,
                            examType,
                        )
                    } else {
                        begin_test_fail(
                            '16_Test_Start_Failure',
                            profileData,
                            examType,
                        )
                    }
                    console.error(err)
                }
            })
    }, [])
    return (
        <div className={styles.testCardContainer}>
            {heading}
            {!isDisabled ? (
                <button
                    onClick={() => handleBeginExam(payload, heading, token)}
                    style={buttonStyles[buttonVariant]}
                    disabled={isDisabled}
                >
                    {buttonLabel}
                </button>
            ) : (
                <div className={styles.disabledBtn}>{buttonLabel}</div>
            )}
        </div>
    )
}

export default PaperCard
